import React, { Fragment, useCallback } from "react";
import { Badge, Icon } from "@culturehq/components";

import { InterestLink } from "app/links";
import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import LazyEditorOutput from "components/editor/LazyEditorOutput";
import { EventComments } from "components/Comments";

const EventTags = ({ event }) => (
  <div className="tags">
    <h2>
      <Trans>TAGS</Trans>
    </h2>

    <>
      <Badge>
        <Icon icon="calendar-star" />
        {event.eventType}
      </Badge>
    </>

    {event.organizationValues.map(value => (
      <Fragment key={value.id}>
        <Badge>
          <Icon icon="diamond" />
          {value.name}
        </Badge>
      </Fragment>
    ))}

    {event.interests.map(interest => (
      <Fragment key={interest.id}>
        <InterestLink interest={interest}>
          <Badge>
            <Icon icon="heart-ol" />
            {interest.name}
          </Badge>
        </InterestLink>
      </Fragment>
    ))}

    {event.locations.map(location => (
      <Badge key={location.id}>
        <Icon icon="loc-ol" />
        {location?.name}
      </Badge>
    ))}

    {event.allLocations && (
      <Badge key="all-Locations">
        <Icon icon="loc-ol" />
        <Trans>All Locations</Trans>
      </Badge>
    )}
  </div>
);

const EventDetails = ({ event }) => (
  <div className="EventDetails col-sm-12">
    <ErrorBoundary>
      <div className="description">
        <h2>
          <Trans>DESCRIPTION</Trans>
        </h2>
        <LazyEditorOutput output={event.details} />
      </div>

      <EventTags event={event} />
    </ErrorBoundary>
    <EventComments event={event} liveComments />
  </div>
);

export default EventDetails;
